import { useState, useEffect, useRef } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { RadioButton } from 'primereact/radiobutton';
import { ColorPicker } from 'primereact/colorpicker';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import Toast from '../../Shared/Toast/Toast';
import { apiBase } from '../../../utils/config';
import { Dialog } from 'primereact/dialog';
import DeleteConfirmation from '../../Dialogs/DeleteConfirmation';
import IdCard1 from '../../../assets/images/IdCard1.png';
import IdCard2 from '../../../assets/images/IdCard2.png'
import IdCard3 from '../../../assets/images/IdCard3.png'
import { InputTextarea } from 'primereact/inputtextarea';
import { useCatchResponse } from '../../../utils/useCatchResponse';
import UploadFile from '../../UploadFile/UploadFile';


const AddEditIdCardTemplate = (props) => {
    const { catchResponse } = useCatchResponse();
    const [securityUserID, setSecurityUserID] = useState("");
    const [templateWidth, setTemplateWidth] = useState(null);
    const [templateHeight, setTemplateHeight] = useState(null);
    const [fontTheme, setFontTheme] = useState(null);
    const [orientation, setOrientation] = useState('vertical');
    const [titleName, setTitleName] = useState('');
    const [titleNameErr, setTitleNameErr] = useState(false);
    const [titleNameErrText, setTitleNameErrText] = useState('');
    const [applySettingTo, setApplySettingTo] = useState('front');
    const [cardType, setCardType] = useState('Student');
    const cardTypeOptions = [
        { label: 'Student', value: 'Student' },
        { label: 'Staff', value: 'Staff' },
    ];
    const [nameBGColor, setNameBGColor] = useState('');
    const [isHouseWiseImage, setIsHouseWiseImage] = useState(false);
    const [nameColor, setNameColor] = useState('');
    const [emailTextColor, setEmailTextColor] = useState('');
    const [baseColor, setBaseColor] = useState('');
    const [staticColor, setStaticColor] = useState('');
    const [backgroundImage, setBackgroundImage] = useState(null);
    const backgroundImgUploadRef = useRef(null);
    const [sigunatureImage, setSigunatureImage] = useState(null);
    const [authorityTitle, setAuthorityTitle] = useState(null);
    const [authorityTitleList, setAuthorityTitleList] = useState([
        { label: 'Principal', value: 'Principal' },
        { label: 'Class Tacher', value: 'Class Teacher' }
    ]);
    const [schoolImage, setSchoolImage] = useState(null);
    const [schoolPreviewImage, setSchoolPreviewImage] = useState(null);
    const schollImgUploadRef = useRef(null);
    const [isDeleteConfirmation, setIsDeleteConfirmation] = useState(false);
    const [isNext, setIsNext] = useState(false);
    const fontThemes = [
        { label: 'Roboto', value: 'Roboto' },
        { label: 'Montserrat', value: 'Montserrat' },
        { label: 'Lato', value: 'Lato' },
        { label: 'Open Sans', value: 'Open Sans' },
        { label: 'Arial', value: 'Arial' },
        { label: 'Source Sans Pro', value: 'Source Sans Pro' },
        { label: 'Helvetica', value: 'Helvetica' },
        { label: 'Poppins', value: 'Poppins' },
        { label: 'Verdana', value: 'Verdana' },
        { label: 'Noto Sans', value: 'Noto Sans' },
        { label: 'Arial Narrow', value: 'Arial Narrow' }
    ];
    const nameTypeList = [
        { label: 'First Name/Surname', value: 'FirstSurname' },
        { label: 'Surname/First Name', value: 'SurnameFirstName' },
        { label: 'First Name/Father Name/Surname', value: 'FirstFatherNameSurname' },
        { label: 'Surname/First Name/Father Name', value: 'SurnameFirstFatherName' },
        { label: 'First Name/Mother Name/Surname', value: 'FirstMotherNameSurname' },
        { label: 'Surname/First Name/Mother Name', value: 'SurnameFirstMotherName' },

    ];
    const [nameType, setNameType] = useState('FirstSurname');
    const [modelType, setModelType] = useState('');
    const [bodyoptionsList, setBodyoptionsList] = useState([]);
    const [selectedTemplate, setSelectedTemplate] = useState(0);
    const [selectedBodyOptions, setSelectedBodyOptions] = useState([]);
    const [draggedIndex, setDraggedIndex] = useState(null);
    const [selectedProfileOptions, setSelectedProfileOptions] = useState('');
    const profileOptionsList = [
        { label: 'Round', value: 'round' },
        { label: 'Rectangle', value: 'rectangle' },
    ];
    const [previewProfilePath, setPreviewProfilePath] = useState('');
    const [previewSignPath, setPreviewSignPath] = useState('');
    const signImgUploadRef = useRef(null);
    const [editingIndex, setEditingIndex] = useState(null);
    const [newOptionValue, setNewOptionValue] = useState("");
    const [classAngle, setClassAngle] = useState('');
    const [emailPhoneTextData, setEmailPhoneTextData] = useState('');
    const barCodeOptionsList = [
        { label: 'All', value: 'all' },
        { label: 'From Start', value: 'fromStart' },
        { label: 'From End', value: 'fromEnd' },
    ];
    const [barCodeOptions, setBarCodeOptions] = useState('');
    const [barCodeValue, setBarCodeValue] = useState('');

    const studentBodyList = [
        { label: 'Academic Year', value: 'AcademicYear' },
        { label: 'Class & Section', value: 'Class&Section' },
        { label: 'Student Name', value: 'StudentName' },
        { label: 'Contact No', value: 'Phone' },
        { label: 'Father Name', value: 'FName' },
        { label: 'GRNo', value: 'GRNo' },
        { label: 'DOB', value: 'DOB' },
        { label: 'Father No', value: 'FPhoneNo' },
        { label: 'Address', value: 'Address' },
        { label: 'Blood Group', value: 'BloodGroup' },
        { label: 'Blood Group with icon', value: 'BloodGroupIcon' },
        { label: 'School Contact No.', value: 'schoolContactNo' },
        { label: 'School Email', value: 'schoolEmail' },
        { label: 'Bar Code Show', value: 'IsBarCodeShow' },
    ];
    const staffBodyList = [
        { label: 'Staff Name', value: 'StudentName' },
        { label: 'Designation', value: 'Designation' },
        { label: 'Qualification', value: 'Qualification' },
        { label: 'Joining Date', value: 'JoiningDate' },
        { label: 'Employee ID', value: 'EmployeeId' },
        { label: 'Contact No', value: 'Phone' },
        { label: 'Email', value: 'Email' },
        { label: 'DOB', value: 'DOB' },
        { label: 'Address', value: 'Address' },
        { label: 'Blood Group', value: 'BloodGroup' },
        { label: 'Blood Group with icon', value: 'BloodGroupIcon' },
        { label: 'School Contact No.', value: 'schoolContactNo' },
        { label: 'School Email', value: 'schoolEmail' },
        { label: 'Bar Code Show', value: 'IsBarCodeShow' },
    ];
    const getBodyList = (type) => (type === 'Staff' ? staffBodyList : studentBodyList);

    const titleNameRef = useRef(null);
    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);

        // Ensure focus after modal renders
        setTimeout(() => {
            titleNameRef.current?.focus();
        }, 100);
    }, []);

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        const type = props?.configId ? (props?.masterData?.CardType || 'Student') : 'Student';
        setCardType(type);
        const bodyList = getBodyList(type);
        if (props?.configId) {
            setTitleName(props?.masterData?.TitleName);
            setApplySettingTo(props?.masterData?.ApplyThisIn);
            setTemplateWidth(props?.masterData?.TemplateWidth);
            setTemplateHeight(props?.masterData?.TemplateHeight);
            setFontTheme(props?.masterData?.FontTheme);
            setClassAngle(CommonConfig.isEmpty(props?.masterData?.ClassAngle) ? '' : props?.masterData?.ClassAngle);
            setOrientation(props?.masterData?.Orientation);
            setNameBGColor(props?.masterData?.NameBGColor ?? '');
            setIsHouseWiseImage(props?.masterData?.IsHouseWiseImage ?? false);
            setSelectedTemplate(props?.masterData?.TemplateName ?? selectedTemplate);
            setSelectedBodyOptions(props?.masterData?.BodySection
                ? props?.masterData?.BodySection.map((item) => {
                    return item?.key;
                })
                : []);
            const existingKeys = new Set(props?.masterData?.BodySection?.map(item => item.key) || []);
            const missingItems = bodyList.filter(item => !existingKeys.has(item.value));
            const updatedBodyOptions = [
                ...(props?.masterData?.BodySection?.map(item => ({
                    value: item?.key,
                    label: item?.label
                })) || []),
                ...missingItems
            ];

            setBodyoptionsList(updatedBodyOptions);
            setSelectedProfileOptions(props?.masterData?.ProfileStyle);
            setNameType(props?.masterData?.NameType ?? 'FirstSurname');
            setNameColor(props?.masterData?.NameColor ?? '');
            setEmailTextColor(props?.masterData?.EmailTextColor ?? '');
            setBaseColor(props?.masterData?.BaseColor ?? '');
            setStaticColor(props?.masterData?.StaticColor ?? '');
            setAuthorityTitle(props?.masterData?.AuthorityTitle);
            setBackgroundImage(props?.masterData?.BackGroundImage ? `${apiBase}/TemplateBackGround/${props?.masterData?.BackGroundImage}` : null);
            setSigunatureImage(props?.masterData?.SignImage ? `${apiBase}/TemplateSign/${props?.masterData?.SignImage}` : null);
            setSchoolImage(props?.masterData?.SchoolImage ? `${apiBase}/TemplateSign/${props?.masterData?.SchoolImage}` : null);
            setEmailPhoneTextData(props?.masterData?.EmailPhoneTextData ?? '');
            setBarCodeOptions(props?.masterData?.BarCodeType ?? '');
            setBarCodeValue(props?.masterData?.BarCodeValue ?? '');
        } else {
            setBodyoptionsList(bodyList)
        }
    }, []);

    const validate = () => {
        let formIsValid = true;
        if (CommonConfig.isEmpty(titleName)) {
            formIsValid = false;
            setTitleNameErr(true);
            setTitleNameErrText("Title Name is required");
        } else {
            setTitleNameErr(false);
            setTitleNameErrText("");
        }
        return formIsValid;
    };

    const onCancel = () => {
        props.onCancel();
    }

    const onChangeCardType = (val) => {
        if (!val) return;
        setCardType(val);
        setBodyoptionsList(getBodyList(val));
        setSelectedBodyOptions([]);
        if (val === 'Staff') setIsHouseWiseImage(false);
    };

    const AddUpdateTemplate = async (e) => {
        if (validate(e)) {
            try {
                let bodySectionData = [];
                if (selectedBodyOptions) {
                    bodySectionData = selectedBodyOptions.map((x, idx) => {
                        if (idx === 1) {
                            return {
                                label: 'Student Profile Pic',
                                key: 'StudentProfilePic'
                            }
                        }
                        return {
                            label: bodyoptionsList.filter(y => y?.value === x)[0]?.label,
                            key: x
                        }
                    })
                }
                const formData = new FormData();
                formData.append("id", props?.masterData?._id ?? '');
                formData.append('TemplateName', selectedTemplate);
                formData.append("TitleName", titleName);
                formData.append("CardType", cardType);
                formData.append("ApplyThisIn", applySettingTo);
                formData.append("TemplateWidth", templateWidth);
                formData.append("TemplateHeight", templateHeight);
                formData.append("FontTheme", fontTheme);
                formData.append("Orientation", orientation);
                formData.append("NameBGColor", !isHouseWiseImage ? (nameBGColor ?? '') : '');
                formData.append("IsHouseWiseImage", isHouseWiseImage);
                formData.append("BodySection", JSON.stringify(bodySectionData));
                formData.append("NameType", nameType);
                formData.append("NameColor", !isHouseWiseImage ? (nameColor ?? '') : '');
                formData.append("EmailTextColor", !isHouseWiseImage ? (emailTextColor ?? '') : '');
                formData.append("BaseColor", selectedTemplate == 0 ? (baseColor ?? '') : '');
                formData.append("StaticColor", selectedTemplate == 1 ? (staticColor ?? '') : '');
                formData.append("ProfileStyle", selectedProfileOptions);
                formData.append("ClassAngle", classAngle);
                formData.append("AuthorityTitle", authorityTitle);
                formData.append("BarCodeType", barCodeOptions);
                formData.append("BarCodeValue", barCodeValue);
                const formattedText = emailPhoneTextData.split("\n").join("\n");
                formData.append("EmailPhoneTextData", formattedText);
                formData.append("CreatedBy", securityUserID);
                if (isHouseWiseImage) {
                    if (backgroundImage && backgroundImage.type) {
                        formData.append("BackGroundImage", backgroundImage);
                    } else if (CommonConfig.isEmpty(backgroundImage)) {
                        formData.append("BackGroundImage", '');
                    }
                } else {
                    formData.append("BackGroundImage", '');
                }
                if (sigunatureImage && sigunatureImage.type) {
                    formData.append("SignImage", sigunatureImage);
                } else if (CommonConfig.isEmpty(sigunatureImage)) {
                    formData.append("SignImage", '');
                }
                if (schoolImage && schoolImage.type) {
                    formData.append("SchoolImage", schoolImage);
                } else if (CommonConfig.isEmpty(schoolImage)) {
                    formData.append("SchoolImage", '');
                }
                Loader.show();
                await api
                    .post(APIConstant.path.AddUpdateIdCardConfig, formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    })
                    .then((response) => {
                        let res = response;
                        if (res.success) {
                            Toast.success({ message: res.message });
                            Loader.hide();
                            onCancel();
                        } else {
                            Toast.error({ message: res.message });
                            Loader.hide();
                            onCancel();
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        Toast.error({ message: err?.data?.message });
                        Loader.hide();
                        onCancel();
                    });
            } catch (err) {
                console.log(err);
                Toast.error({ message: err });
                Loader.hide();
                onCancel();
                catchResponse(err);
            }
        }
    };

    const handleBackGroundImage = (e) => {
        const selectedFile = e.files[0];
        if (selectedFile) {
            const img = new Image();
            img.onload = () => {

                const aspectRatio = img.width / img.height;
                const expectedRatio = 1 / 1;
                const tolerance = 0.01;

                if (Math.abs(aspectRatio - expectedRatio) > tolerance) {
                    if (backgroundImgUploadRef.current) {
                        backgroundImgUploadRef.current.clear();
                    }
                    Toast.error({ message: 'The image must have a 1:1 aspect ratio.' });
                    return;
                }

                setBackgroundImage(selectedFile);
                const fileURL = URL.createObjectURL(selectedFile);
                setPreviewProfilePath(fileURL);

                img.onerror = () => {
                    if (backgroundImgUploadRef.current) {
                        backgroundImgUploadRef.current.clear();
                    }
                    Toast.error({ message: 'Error loading the image.' });
                };
            };
            const reader = new FileReader();
            reader.onload = (event) => {
                img.src = event.target.result;
            };
            reader.readAsDataURL(selectedFile);
        }
    };

    const handleSigunatureImage = (e) => {
        const selectedFile = e.files[0];
        if (selectedFile) {
            const img = new Image();
            img.onload = () => {
                setSigunatureImage(selectedFile);
                const fileURL = URL.createObjectURL(selectedFile);
                setPreviewSignPath(fileURL);
            };
            img.onerror = () => {
                if (signImgUploadRef.current) {
                    signImgUploadRef.current.clear();
                }
                Toast.error({ message: 'Error loading the image.' });
            };

            const reader = new FileReader();
            reader.onload = (event) => {
                img.src = event.target.result;
            };
            reader.readAsDataURL(selectedFile);

        }
    };

    const handleSchoolImage = (e) => {
        const selectedFile = e.files[0];
        if (selectedFile) {
            const img = new Image();
            img.onload = () => {

                const aspectRatio = img.width / img.height;
                const expectedRatio = 3.55/1;
                const tolerance = 0.01;

                if (Math.abs(aspectRatio - expectedRatio) > tolerance) {
                    if (schollImgUploadRef.current) {
                        schollImgUploadRef.current.clear();
                    }
                    Toast.error({ message: 'The image must have a 1:3.55 aspect ratio.' });
                    return;
                }
                setSchoolImage(selectedFile);
                const fileURL = URL.createObjectURL(selectedFile);
                setSchoolPreviewImage(fileURL);
            };
            img.onerror = () => {
                if (schollImgUploadRef.current) {
                    schollImgUploadRef.current.clear();
                }
                Toast.error({ message: 'Error loading the image.' });
            };

            const reader = new FileReader();
            reader.onload = (event) => {
                img.src = event.target.result;
            };
            reader.readAsDataURL(selectedFile);
        }
    };

    const renderFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={handleClose}
            />
            <Button
                label="Delete"
                className="btn-text-action-primary"
                onClick={() => {
                    handleClose();
                    if (modelType === 'Sign') {
                        setSigunatureImage("")
                        setPreviewSignPath();
                        if (signImgUploadRef.current) {
                            signImgUploadRef.current.clear();
                        }
                    } else if (modelType === 'BackGround') {
                        setBackgroundImage("")
                        setPreviewProfilePath();
                        if (backgroundImgUploadRef.current) {
                            backgroundImgUploadRef.current.clear();
                        }
                    } else {
                        setSchoolImage("")
                        setSchoolPreviewImage();
                        if (schollImgUploadRef.current) {
                            schollImgUploadRef.current.clear();
                        }
                    }
                }}
            />
        </div>
    );

    const handleClose = () => {
        setIsDeleteConfirmation(false)
    };

    const handleDragStart = (e, index) => {
        e.dataTransfer.effectAllowed = "move";
        e.dataTransfer.setData("text/plain", index.toString());
        e.currentTarget.classList.add("dragging");
        setEditingIndex(null);
        setNewOptionValue("");
        setDraggedIndex(index);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const startEditing = (index, currentValue) => {
        setEditingIndex(index);
        setNewOptionValue(currentValue);
    };

    const saveEdit = (index) => {
        setBodyoptionsList((prev) =>
            prev.map((option, i) =>
                i === index ? { ...option, label: newOptionValue } : option
            )
        );
        setEditingIndex(null);
        setNewOptionValue("");
    };

    const cancelEdit = () => {
        setEditingIndex(null);
        setNewOptionValue("");
    };

    const handleDrop = (e, index) => {
        e.preventDefault();
        const dragIndex = parseInt(e.dataTransfer.getData("text/plain"), 10);
        document.querySelectorAll('.dragging').forEach(el => el.classList.remove('dragging'));
        const updatedList = [...bodyoptionsList];
        const draggedItem = updatedList[draggedIndex];
        updatedList.splice(draggedIndex, 1);
        updatedList.splice(index, 0, draggedItem);

        setBodyoptionsList(updatedList);
        const updatedSelectedBodyOptions = updatedList
            .filter((item) => selectedBodyOptions.includes(item.value))
            .map((item) => item.value);

        setSelectedBodyOptions(updatedSelectedBodyOptions);
        setDraggedIndex(null);
    };

    const handleCheckBodyboxChange = (e, option) => {
        const value = e.value;
        const isChecked = !selectedBodyOptions?.includes(value);

        setSelectedBodyOptions((prevSelected) =>
            isChecked
                ? [...prevSelected, value]
                : prevSelected.filter((v) => v !== value)
        );
    };


    const handleImageClick = (index) => {
        if (selectedTemplate == index) {
            setSelectedTemplate('');
        } else {
            setSelectedTemplate(index);
        }
    };

    const handleColorChange = (value, type) => {
        if (type === 'NameColor') {
            setNameColor(value);
        } else if (type === 'StaticColor') {
            setStaticColor(value);
        } else if (type === 'NameBGColor') {
            setNameBGColor(value);
        } else if (type === 'BaseColor') {
            setBaseColor(value);
        } else if (type === 'EmailTextColor') {
            setEmailTextColor(value);
        }
    };

    const handleInputChange = (value, type) => {
        let inputValue = value?.trim();
        const alphanumericValue = inputValue.replace(/[^a-zA-Z0-9\s]/g, '');

        if (type === 'NameColor') {
            setNameColor(alphanumericValue);
        } else if (type === 'StaticColor') {
            setStaticColor(alphanumericValue);
        } else if (type === 'NameBGColor') {
            setNameBGColor(alphanumericValue);
        } else if (type === 'BaseColor') {
            setBaseColor(alphanumericValue);
        } else if (type === 'EmailTextColor') {
            setEmailTextColor(alphanumericValue);
        }
    };

    const handleDelete = (type) => {
        setIsDeleteConfirmation(true);
        setModelType(type);
    };

    return (
        <div className="template-config-container">
            <div className='template-body'>
                <div className="image-selection-container">
                    {[IdCard1, IdCard2, IdCard3].map((image, index) => (
                        <img
                            src={image}
                            key={index}
                            alt={`IdCard${index + 1}`}
                            className={`image-item ${selectedTemplate == index ? 'selected' : ''}`}
                            onClick={() => handleImageClick(index)}
                            style={{
                                borderColor: selectedTemplate == index ? '#1c515e' : 'transparent',
                            }}
                        />
                    ))}
                </div>
                {!isNext ? (
                    <div>
                        <div className='section-box'>
                            <h2>Title</h2>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-12">
                                    <div className='custom-inputs'>
                                        <label htmlFor="cardType">Card Type</label>
                                        <div className='s-radiobutton-container'>
                                            <div className='s-radiobutton'>
                                                <RadioButton
                                                    inputId="ctStudent"
                                                    name="cardType"
                                                    value="Student"
                                                    checked={cardType === 'Student'}
                                                    onChange={(e) => onChangeCardType(e.value)}
                                                />
                                                <label htmlFor="ctStudent" className="ml-2">Student</label>
                                                <RadioButton
                                                    inputId="ctStaff"
                                                    name="cardType"
                                                    value="Staff"
                                                    checked={cardType === 'Staff'}
                                                    onChange={(e) => onChangeCardType(e.value)}
                                                />
                                                <label htmlFor="ctStaff" className="ml-2">Staff</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="p-col-6 p-md-6">
                                    <div className='p-w-100'>
                                        <div className='custom-inputs'>
                                            <label htmlFor="titleName">Title Name</label>
                                            <InputText
                                                ref={titleNameRef}
                                                className='p-mt-1 p-w-100'
                                                id="titleName"
                                                value={titleName}
                                                onChange={(e) => setTitleName(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-col-6 p-md-6">
                                    <div className='p-w-100'>
                                        <div className='custom-inputs'>
                                            <label htmlFor="settingthis">Apply this setting to</label>
                                            <div className='s-radiobutton-container'>
                                                <div className='s-radiobutton'>
                                                    <RadioButton
                                                        inputId="front"
                                                        name="applySettingTo"
                                                        value="front"
                                                        checked={applySettingTo === 'front'}
                                                        onChange={(e) => setApplySettingTo(e.value)}
                                                    />
                                                    <label htmlFor="front" className="ml-2">Front</label>
                                                    <RadioButton
                                                        inputId="back"
                                                        name="applySettingTo"
                                                        value="back"
                                                        checked={applySettingTo === 'back'}
                                                        onChange={(e) => setApplySettingTo(e.value)}
                                                    />
                                                    <label htmlFor="back" className="ml-2">Back</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='section-box'>
                            <h2>Layout Settings</h2>
                            <label htmlFor="fontTheme">Font Theme</label>
                            <div className="p-grid">
                                <div className="p-col-6 p-md-6 p-p-0">
                                    <Dropdown id="fontTheme" value={fontTheme} options={fontThemes} onChange={(e) => setFontTheme(e.value)} placeholder="Select a font theme" filter showClear />
                                </div>
                            </div>
                        </div>
                        <div className="header-section p-grid">
                            {cardType !== 'Staff' && (
                                <div className="p-col-12 p-md-12">
                                    <div className="p-field-checkbox p-mr-2 p-mb-0">
                                        <Checkbox
                                            inputId='isHouseWiseImage'
                                            value={isHouseWiseImage}
                                            onChange={(e) => setIsHouseWiseImage(e.checked)}
                                            checked={isHouseWiseImage}
                                        />
                                        <label htmlFor='houseWiseImage'>House Wise BG Image</label>
                                    </div>
                                </div>
                            )}
                            <div className="p-col-12 p-md-6">
                                <UploadFile label='School Logo' note='Select 1:3.55 ratio image' preview={schoolPreviewImage} original={schoolImage} uploadHandler={handleSchoolImage} uploadRef={schollImgUploadRef} handleDelete={handleDelete} isEditAllow={true} aspectRatio={3.55 / 1} />

                                <UploadFile label='BackGround' note='Select 1:1 ratio image' preview={previewProfilePath} original={backgroundImage} uploadHandler={handleBackGroundImage} uploadRef={backgroundImgUploadRef} handleDelete={handleDelete} isEditAllow={true} aspectRatio={1 / 1} />
                            </div>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className='section-box'>
                            <h2>Body Section</h2>
                            <div>
                                {bodyoptionsList.map((option, index) => (
                                    <div
                                        key={option.value}
                                        className="p-d-flex p-jc-between p-my-2"
                                        onDragOver={handleDragOver}
                                        onDrop={(e) => handleDrop(e, index)}
                                        style={{ marginBottom: 0 }}
                                    >
                                        <div className="p-d-flex p-ai-center">
                                            <span
                                                className="pi pi-bars p-mr-2"
                                                draggable
                                                onDragStart={(e) => handleDragStart(e, index)}
                                                title="Drag to reorder"
                                                style={{
                                                    cursor: 'grab',
                                                    userSelect: 'none',
                                                    WebkitUserDrag: 'element'
                                                }}
                                            ></span>
                                            <Checkbox
                                                style={{ userSelect: 'none' }}
                                                inputId={option.value}
                                                value={option.value}
                                                onChange={(e) => handleCheckBodyboxChange(e, option)}
                                                checked={selectedBodyOptions.includes(option.value)}
                                                className="p-mr-2 e-border"
                                            />
                                            {editingIndex === index ? (
                                                <>
                                                    <div className='p-w-100'>
                                                        <div className='custom-inputs'>
                                                            <InputText
                                                                value={newOptionValue}
                                                                onChange={(e) => setNewOptionValue(e.target.value)}
                                                                placeholder="Enter new value"
                                                                className="p-mr-2"
                                                            />
                                                        </div>
                                                    </div>
                                                    {option.value === 'StudentName' &&
                                                        <Dropdown className='p-pl-2 p-mt-0' value={nameType} options={nameTypeList} onChange={(e) => setNameType(e.value)} placeholder="Select value" filter
                                                            showClear />}
                                                </>
                                            ) : (
                                                <>
                                                    <label htmlFor={option.value} className="p-mr-2">{option.label}</label>

                                                </>
                                            )}
                                        </div>
                                        {editingIndex === index ? (
                                            <div className="p-d-flex p-ai-center">
                                                <Button
                                                    icon="pi pi-check"
                                                    className="e-border-btn"
                                                    onClick={() => saveEdit(index)}
                                                />
                                                <Button
                                                    icon="pi pi-times"
                                                    className="e-border-btn p-ml-2"
                                                    onClick={cancelEdit}
                                                />
                                            </div>
                                        ) : <Button
                                            icon="pi pi-pencil"
                                            className="e-border-btn"
                                            onClick={() => {
                                                startEditing(index, option.label)
                                                setNewOptionValue(option.label);
                                            }}
                                        />
                                        }

                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className='section-box'>
                            <h2>Style</h2>
                            <div className='p-grid'>
                                {profileOptionsList.map((option, idx) => (
                                    <div key={option?.value} className="p-col-6">
                                        <Checkbox
                                            inputId={option?.value}
                                            value={option?.value}
                                            onChange={(e) => setSelectedProfileOptions(e.value)}
                                            checked={selectedProfileOptions === option?.value}
                                            className='p-mr-2'
                                        />
                                        <label htmlFor={option?.value}>{option?.label}</label>
                                    </div>
                                ))}
                            </div>
                            <div className='p-grid'>
                                <div className="p-col-6 ">
                                    <label htmlFor="fontTheme">Bar Code Type</label>
                                    <Dropdown id="barCodeOptions" className='p-w-100 p-mt-2' value={barCodeOptions} options={barCodeOptionsList} onChange={(e) => setBarCodeOptions(e.value)} placeholder="Select type" filter
                                        showClear />
                                </div>
                                {(barCodeOptions !== 'all' && barCodeOptions !== '') &&
                                    <div className="p-col-6">
                                        <div className='p-w-100'>
                                            <div className='custom-inputs'>
                                                <label htmlFor="barCodeValue">Bar Code</label>
                                                <InputNumber className='p-mt-2 p-w-100' id="barCodeValue" value={barCodeValue} maxLength={3} onValueChange={(e) => setBarCodeValue(e.value)} />
                                            </div>
                                        </div>
                                    </div>}
                                <div className="p-col-6 ">
                                    <div className='p-w-100'>
                                        <div className='custom-inputs'>
                                            <label htmlFor="classAngle">Class Angle</label>
                                            <InputNumber className='p-mt-2 p-w-100' id="classAngle" value={classAngle} maxLength={3} onValueChange={(e) => setClassAngle(e.value)} />
                                        </div>
                                    </div>
                                </div>
                                {!isHouseWiseImage && (
                                    <div className="p-col-6">
                                        <div className='p-w-100'>
                                            <div className='custom-inputs password-field'>
                                                <label htmlFor='nameColor'>Name Color</label>
                                                <InputText
                                                    className="p-mt-2 p-w-100"
                                                    value={nameColor.toUpperCase()}
                                                    onChange={(e) => handleInputChange(e.target.value, 'NameColor')}
                                                    maxLength={8}
                                                />
                                                <div className='absolute-icons'>
                                                    <ColorPicker
                                                        value={nameColor.replace("#", "")}
                                                        onChange={(e) => handleColorChange(e.value, 'NameColor')}
                                                        className='tailer-icon'
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>)}
                                {!isHouseWiseImage && (
                                    <div className="p-col-6">
                                        <div className='p-w-100'>
                                            <div className='custom-inputs password-field'>
                                                <label htmlFor='emailTextColor'>Email Text Color</label>
                                                <InputText
                                                    className="p-mt-2 p-w-100"
                                                    value={emailTextColor?.toUpperCase()}
                                                    onChange={(e) => handleInputChange(e.target.value, 'EmailTextColor')}
                                                    maxLength={8}
                                                />
                                                <div className='absolute-icons'>
                                                    <ColorPicker
                                                        value={emailTextColor?.replace("#", "")}
                                                        onChange={(e) => handleColorChange(e.value, 'EmailTextColor')}
                                                        className='tailer-icon'
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>)}
                                {selectedTemplate == 0 && (<div className="p-col-6">
                                    <div className='p-w-100'>
                                        <div className='custom-inputs password-field'>
                                            <label htmlFor='baseColor'>Border Color</label>
                                            <InputText
                                                className="p-mt-2 p-w-100"
                                                value={baseColor.toUpperCase()}
                                                onChange={(e) => handleInputChange(e.target.value, 'BaseColor')}
                                                maxLength={8}
                                            />
                                            <div className='absolute-icons'>
                                                <ColorPicker
                                                    value={baseColor.replace("#", "")}
                                                    onChange={(e) => handleColorChange(e.value, 'BaseColor')}
                                                    className='tailer-icon'
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>)}
                                {selectedTemplate == 1 && (
                                    <div className="p-col-6">
                                        <div className='p-w-100'>
                                            <div className='custom-inputs password-field'>
                                                <label htmlFor='borderStaticColor'>Border Static Color</label>
                                                <InputText
                                                    className="p-mt-2 p-w-100"
                                                    value={staticColor.toUpperCase()}
                                                    onChange={(e) => handleInputChange(e.target.value, 'StaticColor')}
                                                    maxLength={8}
                                                />
                                                <div className='absolute-icons'>
                                                    <ColorPicker
                                                        value={staticColor.replace("#", "")}
                                                        onChange={(e) => handleColorChange(e.value, 'StaticColor')}
                                                        className='tailer-icon'
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                )}
                                {!isHouseWiseImage && (
                                    <div className="p-col-6">
                                        <div className='p-w-100'>
                                            <div className='custom-inputs password-field'>
                                                <label htmlFor='nameBGColor'>Name BG Color</label>
                                                <InputText
                                                    className="p-mt-2 p-w-100"
                                                    value={nameBGColor?.toUpperCase()}
                                                    onChange={(e) => handleInputChange(e.target.value, 'NameBGColor')}
                                                    maxLength={8}
                                                />
                                                <div className='absolute-icons'>
                                                    <ColorPicker
                                                        value={nameBGColor.replace("#", "")}
                                                        onChange={(e) => handleColorChange(e.value, 'NameBGColor')}
                                                        className='tailer-icon'
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className='section-box'>
                            <h2>Footer Section</h2>
                            <div className='p-grid'>
                                <div className="p-col-6">
                                    <label htmlFor="authorityTitle">Authority Title</label>
                                    <Dropdown id="authorityTitle" className='p-w-100 p-mt-2' value={authorityTitle} options={authorityTitleList} onChange={(e) => setAuthorityTitle(e.value)} placeholder="Select Authority Title" filter showClear />
                                </div>
                                <div className="p-col-6">
                                    <div className='p-w-100'>
                                        <div className='custom-inputs'>
                                            <label htmlFor="emailPhoneTextData">Email Phone Text Data</label>
                                            <InputTextarea id="emailPhoneTextData" className='p-w-100 p-mt-2' value={emailPhoneTextData} onChange={(e) => setEmailPhoneTextData(e.target.value)} maxLength={500} rows={3} cols={30} />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-col-6">
                                    <UploadFile label='Sign' note='' preview={previewSignPath} original={sigunatureImage} uploadHandler={handleSigunatureImage} uploadRef={signImgUploadRef} handleDelete={handleDelete} isEditAllow={true} aspectRatio={null} />
                                </div>
                            </div>
                        </div>
                    </>)
                }
            </div>
            {!isNext ? (
                <div className='dialog-footer p-mx-2'>
                    <Button className='btn-text-action-primary' label="Next" onClick={(e) => setIsNext(true)} />
                </div>
            ) : <div className='dialog-footer p-mx-2'>
                <Button className='btn-text-action-secondary' label="Back" onClick={(e) => setIsNext(false)} />
                <Button className='btn-text-action-primary' label="Save" onClick={(e) => AddUpdateTemplate()} />
            </div>}
            <Dialog
                visible={isDeleteConfirmation}
                onHide={handleClose}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Delete Confirmation</span>
                    </div>
                }
                footer={renderFooter()}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <DeleteConfirmation />
            </Dialog>
        </div >
    );
};

export default AddEditIdCardTemplate;
